import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { getDepartureDate } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';
import { t } from 'Src/i18n';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { formatDate } from 'Utils/date/dateUtils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  arrivalDate: string;
  className?: string;
  duration: number;
  resort: Readonly<{
    image?: string;
    name: string;
  }>;
};
export const AlternativeDateSuggestionHeader = ({
  arrivalDate,
  className,
  duration,
  resort,
}: Props) => {
  const getFormattedDateTitle = formatDate('DD/MM');
  const departureDate = getDepartureDate({
    date: arrivalDate,
    duration,
    format: API_DATE_FORMAT,
    unit: 'days',
  });
  return (
    <h2
      className={classnames(
        'flex items-start gap-10 font-brand text-24 leading-tight text-black md:text-28 lg:text-32',
        className,
      )}
      data-testid="AlternativeDate"
    >
      <Icon className="shrink-0 text-orange" hasRtl name={ICONS.WARNING} width="2em" />
      <span>
        <TemplateString
          className="block"
          template={t('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel')}
          values={{
            resortName: resort.name,
          }}
        />
        <TemplateString
          className="block text-orange"
          template={t('booking.counterProposalPopIn.notAvailableDates')}
          values={{
            arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
            departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || '',
          }}
        />
      </span>
    </h2>
  );
};
